module.exports = __webpack_public_path__ + "img/quana_07.2f512ce5.png";